import _ from 'lodash'

export function parse(s, fallback?) {
  try {
    return JSON.parse(s)
  } catch(e) {
    console.debug(e)
    return _.isNil(fallback) ? null : fallback
  }
}

export function local(key, fallback?, noparse?) {
  let val = localStorage[key]
  if(key === 'auth.token') {
    val = sessionStorage[key]
  }
  return (noparse || val === undefined) ? (val || fallback) : parse(val, fallback)
}

export function setlocal(key, value, json=true) {
  const val = json ? JSON.stringify(value) : value
  if(key === 'auth.token') {
    sessionStorage[key] = val
  } else {
    localStorage[key] = val
  }
  if(key === "folderPath") window.dispatchEvent(new Event("set-folder-path"))
}

export function clearlocal(key) {
  localStorage.removeItem(key)
}
